import React, { useState } from "react";
import "./App.css";
// import "./fireflies.css";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/configStore";
import { Route, Routes, BrowserRouter, Redirect } from "react-router-dom";
import TransactionInfo from "./views/TransactionInfo";
import QrCardInfo from "./views/QrCardInfo";
import { useParams } from "react-router";
import NotFound from "./views/NotFound";
import TrueMoneyForm from "./components/TrueMoneyForm";
import AutoMethodTransactionInfoCard from "./components/AutoMethodTransactionInfoCard";
import MyrTransactionInfo from "./views/MyrTransactionInfo";
import MyrSuccessScreen from "./components/MyrSuccessScreen";
import IdrMethodTransactionInfoCard from "./components/IdrMethodTransactionInfoCard";
import IdrQrCardInfo from "./views/IdrQrCardInfo";
import IdrTransactionInfo from "./views/IdrTransactionInfo";
import CnyTransactionInfo from "./views/CnyTransactionInfo";
import ConfirmationAndWarningTrueMoney from "./views/ConfirmationAndWarningTrueMoney";
import Layout from "./views/Layout";
import PayWithFPX from "./views/fpx/PayWithFPX";
import FpxRedirecting from "./views/fpx/FpxRedirecting";
import FpxPrint from "./views/fpx/FpxPrint";
import LineLayout from "./views/LineLayout";
import FpxMyrTransactionInfo from "./views/fpx/FpxMyrTransactionInfo";
import VNDTransactionInfo from "./views/vnd/VNDTransactionInfo";
import OnePayTransactionInfo from "./views/thb-onepay/OnePayTransactionInfo";
import VNDqrCodeInfo from "./views/vnd/VNDqrCodeInfo";
import VNDEFGQrCodeInfo from "./views/vnd/VNDEFGQrCodeInfo";
import DuitNowQrCardInfo from "./views/DuitNowQrCardInfo";
import SgdTransactionInfo from "./views/sgd/SgdTransactionInfo";
import SgdQrCardInfo from "./views/sgd/SgdQrCardInfo";

const App = (props) => {
  const [lang, setLang] = useState("th");

  // Define routes that need a different layout
  const lineLayoutRoutes = ["/myr", "/myr/pay-with-fpx", "/myr/fpx-redirecting", "/myr/fpx-transaction-status", "/myr/fpx-error"];

  // Check if the current route matches a no-layout route, ensuring "/myrfpx" is excluded
  const LayoutRoute = lineLayoutRoutes.some(
    (route) => window.location.pathname.startsWith(route) && !window.location.pathname.startsWith("/myrfpx")
  );


  // Disable right-click
  // document.addEventListener("contextmenu", (e) => e.preventDefault());
  // function ctrlShiftKey(e, keyCode) {
  //   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  // }
  // document.onkeydown = (e) => {
  //   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
  //   if (
  //     e.keyCode === 123 ||
  //     ctrlShiftKey(e, "I") ||
  //     ctrlShiftKey(e, "J") ||
  //     ctrlShiftKey(e, "C") ||
  //     (e.ctrlKey && e.keyCode === "U".charCodeAt(0))
  //   )
  //     return false;
  // };

  return (

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          {LayoutRoute ?
            <LineLayout>
              <Routes>
                {/* ================ROUTES FOR MYR============== */}
                <Route
                  path={`/myr/fpx-transaction-status`}
                  element={<FpxPrint />}
                />

                <Route
                  path={`/myr/fpx-error/:id`}
                  element={<FpxMyrTransactionInfo />}
                />

                <Route
                  path={`/:method/:id`}
                  element={<FpxMyrTransactionInfo />}
                />

                <Route
                  path={`/:method/check-transaction/:id`}
                  element={<MyrSuccessScreen />}
                />

                <Route
                  path={`/myr/pay-with-fpx/:id`}
                  element={<PayWithFPX />}
                />

                <Route
                  path={`/myr/fpx-redirecting/:id`}
                  element={<FpxRedirecting />}
                />
               
                {/* ===========ROUTES FOR MYR DUITQR============== */}
                <Route
                  path="/:method/:id/duitnowqr-payment-method/qr-code-info"
                  element={<DuitNowQrCardInfo lang={lang} />}
                />
              </Routes>
            </LineLayout>
            :
            <Layout>
              <Routes>
                <Route path="*" element={<NotFound />} />
                <Route path={`/:id`} element={<TransactionInfo />} />
                <Route
                  path={`/:id/bypass-payment-method`}
                  element={<AutoMethodTransactionInfoCard lang={lang} />}
                />
                <Route
                  path={`/:id/auto-payment-method`}
                  element={<AutoMethodTransactionInfoCard lang={lang} />}
                />
                <Route
                  path={`/:id/truemoney-payment-method`}
                  element={<TrueMoneyForm lang={lang} />}
                />
                <Route
                  path={`/:id/confirmation-warning-thaiqr`}
                  element={<ConfirmationAndWarningTrueMoney lang={lang} />}
                />
                <Route
                  path="/:id/:type/qr-code-info"
                  element={<QrCardInfo lang={lang} />}
                />
                

                {/* ===========ROUTES FOR THB ONEPAY============== */}
                <Route
                  path={`/:id/onepay-payment-method`}
                  element={<OnePayTransactionInfo lang={lang} />}
                />

                {/* ===========ROUTES FOR CNY============== */}
                <Route
                  path={`/cny/:id`}
                  element={<CnyTransactionInfo lang={lang} />}
                />

                {/* ===========ROUTES FOR VND============== */}
                <Route
                  path={`/vnd/:id`}
                  element={<VNDTransactionInfo lang={lang} />}
                />
                <Route
                  path={`/vnd/:id/qr-code-info`}
                  element={<VNDqrCodeInfo lang={lang} />}
                />
                <Route
                  path={`/vnd/:id/vndefg-qr-code-info`}
                  element={<VNDEFGQrCodeInfo lang={lang} />}
                />

                {/* ===========ROUTES FOR SGD============== */}
                <Route
                  path="/sgd/:id"
                  element={<SgdTransactionInfo />}
                />
                <Route
                  path="/sgd/:id/qr-code-info"
                  element={<SgdQrCardInfo />}
                />

                {/* ================ROUTES FOR MYR============== */}
                <Route path={`/:method/:id`} element={<MyrTransactionInfo />} />
                <Route
                  path={`/:method/check-transaction/:id`}
                  element={<MyrSuccessScreen />}
                />
                {/* ================ROUTES FOR CHECK TRANSACTION STATUS OF ONEPAY============== */}
                <Route 
                  path={`/:method/check-transaction/:id/:userId`}
                  element={<MyrSuccessScreen />}
                />

                {/* ===========ROUTES FOR IDR============== */}
                <Route
                  path={`/idromp/:id`}
                  element={<IdrTransactionInfo lang={lang} />}
                />
                <Route
                  path="/idromp/:idrType/:id/qr-code-info"
                  element={<IdrQrCardInfo lang={lang} />}
                />
                
              </Routes>
            </Layout>}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
